import { defineMessages } from 'react-intl';

export const scope = 'components.VisibilityActionButton';

export default defineMessages({
  isSet: {
    id: `${scope}.isSet`,
    defaultMessage: 'Edit display logic',
  },
  isNotSet: {
    id: `${scope}.isNotSet`,
    defaultMessage: 'Add display logic',
  },
  cannotSet: {
    id: `${scope}.cannotSet`,
    defaultMessage:
      'At least one non carry forward {type} must be excluded from display logic. To add a new rule, first delete an existing one.',
  },
  cannotSetDueToQuotas: {
    id: `${scope}.cannotSetDueToQuotas`,
    defaultMessage:
      "Display logic can't be used  when answers quotas are enabled.",
  },
  cannotSetDueToMinimumResponses: {
    id: `${scope}.cannotSetDueToMinimumResponses`,
    defaultMessage:
      "Display logic can't be used when minimum responses is enabled.",
  },
  error: {
    id: `${scope}.error`,
    defaultMessage:
      'Please keep at least one non carry forward {type} without display logic.',
  },
  limitOutOfBoundsForVisibility: {
    id: `${scope}.limitOutOfBoundsForVisibility`,
    defaultMessage:
      'Min value of limit answers setting must be less than or equal of the number of non carry forward answers without display logic.',
  },
  onlyOneNodeRuleAllowed: {
    id: `${scope}.onlyOneNodeRuleAllowed`,
    defaultMessage:
      'At the moment, users can apply only one display logic rule per question',
  },
});
